import { Show, onMount } from 'solid-js';
import { Button } from '~shared/ui/Button';
import { Card } from '~shared/ui/Card';
import { ErrorText } from '~shared/ui/ErrorText';
import { Spinner } from '~shared/ui/Spinner';
import {
  initSnapshot,
  refreshSnapshot,
  snapshotState,
} from '~/stores/snapshotStore';

export function Setup() {
  onMount(() => void initSnapshot());

  const busy = () => snapshotState.loading || snapshotState.refreshing;

  return (
    <Card>
      <section class="flex flex-col gap-3" aria-labelledby="setup-heading">
        <div class="flex flex-wrap items-center justify-between gap-3">
          <h2 id="setup-heading" class="text-base font-semibold">
            Airtable snapshot
          </h2>
          <Button
            kind="primary"
            disabled={busy()}
            onClick={() => refreshSnapshot()}
          >
            {snapshotState.refreshing ? 'Refreshing…' : 'Refresh from Airtable'}
          </Button>
        </div>

        <Show when={busy() && !snapshotState.snapshot}>
          <div
            class="text-muted flex items-center gap-2 text-sm"
            aria-live="polite"
          >
            <Spinner />
            <span>
              {snapshotState.refreshing
                ? 'Pulling the full base from Airtable — this takes a few seconds.'
                : 'Loading snapshot…'}
            </span>
          </div>
        </Show>

        <Show when={snapshotState.snapshot}>
          {(s) => (
            <p
              class="text-muted flex flex-wrap items-center gap-2 text-xs"
              aria-live="polite"
            >
              <Show when={snapshotState.refreshing}>
                <Spinner class="size-3" label="Refreshing" />
                <span>Refreshing in the background —</span>
              </Show>
              <span>
                {s().members.length} members · {s().teams.length} teams across{' '}
                {s().seasons.length} seasons · {s().clinics.length} clinics
                across {s().terms.length} terms · generated{' '}
                {new Date(s().generatedAt).toLocaleString()}
              </span>
            </p>
          )}
        </Show>

        <Show when={snapshotState.error}>
          <ErrorText>{snapshotState.error}</ErrorText>
        </Show>
      </section>
    </Card>
  );
}
